import { ReactElement } from 'react';

import { MultiUpload } from '@hh.ru/magritte-ui-upload/MultiUpload';
import { SingleUpload } from '@hh.ru/magritte-ui-upload/SingleUpload';
import { UploadProps } from '@hh.ru/magritte-ui-upload/types';

const Upload = ({ multiple, noDragEventsBubbling = true, ...uploadProps }: UploadProps): ReactElement => {
    if (multiple) {
        return <MultiUpload noDragEventsBubbling={noDragEventsBubbling} {...uploadProps} />;
    }
    return <SingleUpload noDragEventsBubbling={noDragEventsBubbling} {...uploadProps} />;
};

export { Upload };
